import Banner from '@/components/component-pool/component/Banner';
import BannerArray from '@/components/component-pool/component/BannerArray';
import BannerBlock from '@/components/component-pool/component/BannerBlock';
import BannerLine from '@/components/component-pool/component/BannerLine';
import BannerNotice from '@/components/component-pool/component/BannerNotice';
import Block from '@/components/component-pool/component/Block';
import Button from '@/components/component-pool/component/Button';
import CardLine from '@/components/component-pool/component/CardLine';
import CarouselBanner from '@/components/component-pool/component/CarouselBanner';
import CarouselFeed from '@/components/component-pool/component/CarouselFeed';
import CategoriesFilterList from '@/components/component-pool/component/CategoriesFilterList';
import CouponContainer from '@/components/component-pool/component/ClaimCoupon';
import SingleCoupon from '@/components/component-pool/component/SingleCoupon';
import CollectionsV2 from '@/components/component-pool/component/CollectionV2';
import ComplexTitle from '@/components/component-pool/component/ComplexTitle';
import ContentFeed from '@/components/component-pool/component/ContentFeed';
import ContentFeedV2 from '@/components/component-pool/component/ContentFeedV2';
import Cuisines from '@/components/component-pool/component/Cuisines';
import Divider from '@/components/component-pool/component/Divider';
import FeaturedThisWeek from '@/components/component-pool/component/FeaturedThisWeek';
import ProductLine from '@/components/component-pool/component/ItemLine';
import LightningDeals from '@/components/component-pool/component/LightningDeals';
import MkplCouponList from '@/components/component-pool/component/MkplCouponList';
import ProductArray from '@/components/component-pool/component/ProductArray';
import ProductList from '@/components/component-pool/component/ProductList';
import ProductListWaterfall from '@/components/component-pool/component/ProductListWaterfall';
import RecommendProductList from '@/components/component-pool/component/RecommendProductList';
import SearchBar from '@/components/component-pool/component/SearchBar';
import SingleProduct from '@/components/component-pool/component/SingleProduct';
import TrendingStoresList from '@/components/component-pool/component/StoresCardList';
import StoresDetailsCardList from '@/components/component-pool/component/StoresDetailsList';
import Text from '@/components/component-pool/component/Text';
import ThemeSpecial from '@/components/component-pool/component/ThemeSpecial';
import Title from '@/components/component-pool/component/Title';
import TitleRich from '@/components/component-pool/component/TitleRich';
import TopMessage from '@/components/component-pool/component/TopMessage';
import TopMessageV2 from '@/components/component-pool/component/TopMessageV2';
import TrendingPost from '@/components/component-pool/component/TrendingPost';
import Video from '@/components/component-pool/component/Video';
import BannerTheme from './component/BannerTheme';
import BigProductLine from './component/BigProductLine';
import ItemLineWithTabs from './component/ItemLineWithTabs';
import NavigationLine from './component/NavigationLine';
import TextArray from './component/TextArray';
import TopMessageV3 from './component/TopMessageV3';
import LayoutLar from '@/components/component-pool/component/LayoutLar';
import SubBanner from '@/components/component-pool/sub-component/Banner';
import SubTrending from '@/components/component-pool/sub-component/Trending';
import PersonalizedCoupon from './component/PersonalizedCoupon';
import Countdown from '@/components/component-pool/component/Countdown';
import RaffleOrderList from './component-ssr/RaffleOrderList';
import HeroVideo from './component-ssr/hero-video';
import FeaturedContent from './component-ssr/featured-content';
import Introduce from './component/Introduce';
import CarouselBannerSsr from './component/CarouselBanner/carousel-banner-ssr';

export enum CmsComponentKeys {
  CM_ITEM_LINE = 'cm_product_line', // = 'cm_item_line',
  CM_ITEM_LINE_TABS = 'cm_product_line_tabs',
  CM_ITEM_LIST_WATERFALL = 'cm_product_waterfall',
  CM_ITEM_LIST = 'cm_product_list',
  CM_ITEM_ARRAY = 'cm_product_array',
  CM_BANNER = 'cm_banner',
  CM_CAROUSEL_BANNER = 'cm_carousel_banner',
  CM_TITLE = 'cm_title',
  CM_TEXT = 'cm_text',
  CM_BUTTON = 'cm_button',
  CM_DIVIDER = 'cm_divider',
  CM_VIDEO = 'cm_video',
  CM_BLOCK = 'cm_block',
  CM_PRODUCT = 'cm_product_single',
  CM_BANNER_ARRAY = 'cm_banner_array',
  CM_CONTENT_FEED = 'cm_content_feed',
  CM_CONTENT_FEED_V2 = 'cm_content_feed_v2',
  TRENDING_STORES = 'cm_mkpl_seller_line',
  ALL_STORES = 'cm_mkpl_seller_list',
  CM_MAIN_BANNER = 'cm_main_banner',
  CM_ITEM_LINE_V2 = 'cm_item_line_v2',
  CM_SEARCH_BAR = 'cm_search_bar',
  CM_TOP_MESSAGE = 'cm_top_message',
  CM_CATEGORIES = 'cm_categories',
  CM_COLLECTION_V2 = 'cm_collection_v2',
  CM_FEATURED_THIS_WEEK = 'cm_featured_this_week',
  CM_TRENDING_POST = 'cm_trending_post',
  CM_CUISINES = 'cm_cuisines',
  CM_RECOMMEND = 'cm_recommend',
  CM_THEME = 'cm_theme',
  CM_LIGHTNING_DEALS = 'cm_lightning_deals',
  CM_BANNER_LINE = 'cm_banner_line',
  CM_NOTICE_BANNER = 'cm_notice_banner',
  CM_COMPLEX_TITLE = 'cm_complex_title',
  CM_BANNER_CONTAINER = 'cm_banner_container',
  CM_CARD_LINE = 'cm_card_line',
  CM_CAROUSEL_FEED = 'cm_carousel_feed',
  CM_COUPON_LIST = 'cm_coupon_list',
  CM_SINGLE_COUPON = 'cm_single_coupon',
  CM_TITLE_RICH = 'cm_title_rich',
  CM_NAVIGATION_LINE = 'cm_navigation_line',
  CM_TEXT_ARRAY = 'cm_text_array',
  CM_NAV_LINE = 'cm_nav_line',
  CM_COUPON = 'cm_coupon',
  CM_COUNTDOWN = 'cm_countdown',
  CM_NAVIGATION = 'cm_page_nav',
  CM_PROMOTION = 'cm_promotion',
  CM_MARKDOWN = 'cm_markdown',
  CM_RAFFLE_ORDER = 'cm_raffle_order_list',
  CM_RAFFLE_AWARD_LIST = 'cm_raffle_award_list',
  CM_FEATURED_HEADER = 'cm_featured_header',
  CM_FEATURED_PRODUCT = 'cm_featured_product',
  CM_FEATURED_CONTENT = 'cm_featured_content',
  CM_HERO_VIDEO = 'cm_hero_video',
  CM_HTML = 'cm_html',
  CM_JSON = 'cm_json',
  CM_INTRODUCE = 'cm_introduce',
  //billboard
  CM_BANNER_THEME = 'cm_banner_theme',
  CM_TOP_MEESSAGE_V2 = 'cm_top_message_v2',
  CM_TOP_MEESSAGE_V3 = 'cm_top_message_v3',
  CM_BIG_PRODUCT_LINE = 'cm_big_product_line',
  CM_PERSONALIZED_COUPON = 'cm_personalized_coupon', // 促销banner

  // layout
  CM_LAYOUT_LAR = 'cm_layout_lar',
  CM_SUB_BANNER = 'cm_layout_vertical_banner',
  CM_SUB_TRENDING = 'cm_layout_text_array',
  CM_SUB_BANNER_LIST = 'cm_layout_banner_list'
}

export enum CmsLayoutKeys {
  LAYOUT_COLUMN = 'layout_column'
}

export const COMPONENT_POOL = {
  [CmsComponentKeys.CM_BANNER]: Banner,
  [CmsComponentKeys.CM_BUTTON]: Button,
  [CmsComponentKeys.CM_CAROUSEL_BANNER]: CarouselBanner,
  [CmsComponentKeys.CM_MAIN_BANNER]: CarouselBannerSsr,
  [CmsComponentKeys.CM_DIVIDER]: Divider,
  [CmsComponentKeys.CM_ITEM_ARRAY]: ProductArray,
  [CmsComponentKeys.CM_ITEM_LINE]: ProductLine,
  [CmsComponentKeys.CM_BIG_PRODUCT_LINE]: BigProductLine,
  [CmsComponentKeys.CM_ITEM_LINE_TABS]: ItemLineWithTabs,
  [CmsComponentKeys.CM_ITEM_LINE_V2]: ProductLine,
  [CmsComponentKeys.CM_ITEM_LIST]: ProductList,
  [CmsComponentKeys.CM_ITEM_LIST_WATERFALL]: ProductListWaterfall,
  [CmsComponentKeys.CM_TEXT]: Text,
  [CmsComponentKeys.CM_TITLE]: Title,
  [CmsComponentKeys.CM_VIDEO]: Video,
  [CmsComponentKeys.CM_BLOCK]: Block,
  [CmsComponentKeys.CM_PRODUCT]: SingleProduct,
  [CmsComponentKeys.TRENDING_STORES]: TrendingStoresList,
  [CmsComponentKeys.ALL_STORES]: StoresDetailsCardList,
  [CmsComponentKeys.CM_SEARCH_BAR]: SearchBar,
  [CmsComponentKeys.CM_TOP_MESSAGE]: TopMessage,
  [CmsComponentKeys.CM_COLLECTION_V2]: CollectionsV2,
  [CmsComponentKeys.CM_FEATURED_THIS_WEEK]: FeaturedThisWeek,
  [CmsComponentKeys.CM_TRENDING_POST]: TrendingPost,
  [CmsComponentKeys.CM_CUISINES]: Cuisines,
  [CmsComponentKeys.CM_RECOMMEND]: RecommendProductList,
  [CmsComponentKeys.CM_THEME]: ThemeSpecial,
  [CmsComponentKeys.CM_LIGHTNING_DEALS]: LightningDeals,
  [CmsComponentKeys.CM_BANNER_LINE]: BannerLine,
  [CmsComponentKeys.CM_NOTICE_BANNER]: BannerNotice,
  [CmsComponentKeys.CM_CATEGORIES]: CategoriesFilterList,
  [CmsComponentKeys.CM_BANNER_ARRAY]: BannerArray,
  [CmsComponentKeys.CM_CONTENT_FEED]: ContentFeed,
  [CmsComponentKeys.CM_CONTENT_FEED_V2]: ContentFeedV2,
  [CmsComponentKeys.CM_COMPLEX_TITLE]: ComplexTitle,
  [CmsComponentKeys.CM_BANNER_CONTAINER]: BannerBlock,
  [CmsComponentKeys.CM_CARD_LINE]: CardLine,
  [CmsComponentKeys.CM_CAROUSEL_FEED]: CarouselFeed,
  [CmsComponentKeys.CM_COUPON_LIST]: MkplCouponList,
  [CmsComponentKeys.CM_SINGLE_COUPON]: SingleCoupon,
  [CmsComponentKeys.CM_TITLE_RICH]: TitleRich,
  [CmsComponentKeys.CM_NAVIGATION_LINE]: NavigationLine,
  [CmsComponentKeys.CM_TEXT_ARRAY]: TextArray,
  [CmsComponentKeys.CM_NAV_LINE]: NavigationLine,
  [CmsComponentKeys.CM_COUPON]: CouponContainer,
  [CmsComponentKeys.CM_BANNER_THEME]: BannerTheme,
  [CmsComponentKeys.CM_TOP_MEESSAGE_V2]: TopMessageV2,
  [CmsComponentKeys.CM_TOP_MEESSAGE_V3]: TopMessageV3,
  [CmsComponentKeys.CM_LAYOUT_LAR]: LayoutLar,
  [CmsComponentKeys.CM_PERSONALIZED_COUPON]: PersonalizedCoupon,
  [CmsComponentKeys.CM_COUNTDOWN]: Countdown,
  [CmsComponentKeys.CM_RAFFLE_ORDER]: RaffleOrderList,
  [CmsComponentKeys.CM_HERO_VIDEO]: HeroVideo,
  [CmsComponentKeys.CM_FEATURED_CONTENT]: FeaturedContent,
  [CmsComponentKeys.CM_INTRODUCE]: Introduce
};

/**
 * 用于团购的组件池
 * 不能有向外跳转的组件和链接, 否则会影响团购的跳转
 * 若有通用新增, 这里应该不需要同步(除了类产品卡片组件)
 */
export const COMPONENT_POOL_FOR_MKPL_GROUP_ORDER = {
  // [CmsComponentKeys.CM_BANNER]: Banner,
  // [CmsComponentKeys.CM_CAROUSEL_BANNER]: CarouselBanner,
  // [CmsComponentKeys.CM_VIDEO]: Video,
  // [CmsComponentKeys.CM_BUTTON]: Button,
  [CmsComponentKeys.CM_DIVIDER]: Divider,
  [CmsComponentKeys.CM_ITEM_ARRAY]: ProductArray,
  [CmsComponentKeys.CM_ITEM_LINE]: ProductLine,
  [CmsComponentKeys.CM_ITEM_LIST]: ProductList,
  [CmsComponentKeys.CM_ITEM_LIST_WATERFALL]: ProductListWaterfall,
  [CmsComponentKeys.CM_TEXT]: Text,
  [CmsComponentKeys.CM_TITLE]: Title,
  [CmsComponentKeys.CM_BLOCK]: Block,
  [CmsComponentKeys.CM_PRODUCT]: SingleProduct,
  [CmsComponentKeys.CM_LIGHTNING_DEALS]: LightningDeals
};

export const LAYOUT_COMPONENT_POOL = {
  [CmsComponentKeys.CM_SUB_BANNER]: SubBanner,
  [CmsComponentKeys.CM_SUB_TRENDING]: SubTrending,
  [CmsComponentKeys.CM_SUB_BANNER_LIST]: SubBanner
};
